module.exports = Em.Controller.extend(Em.Evented, {
    isDev: true
})
